/**
 * Icon geometry for morphicons' `MorphIcon`, which animates between two
 * stroke-based icons.
 *
 * These are the `d` attributes of lucide's `chevron-down` and `chevron-up`,
 * copied rather than imported: morphicons takes a raw `d` string, and lucide is
 * not one of its peers, so importing the data would mean adding the vanilla
 * `lucide` package alongside the `lucide-react` and `lucide-react-native` the
 * two apps already carry — a third copy of the same icon set for two paths.
 *
 * Re-copy from `lucide-react/dist/esm/icons/chevron-{down,up}.js` if lucide ever
 * redraws them.
 */

/** lucide `chevron-down`. */
export const CHEVRON_DOWN_PATH = "m6 9 6 6 6-6";

/** lucide `chevron-up`. */
export const CHEVRON_UP_PATH = "m18 15-6-6-6 6";
